<!-- Cabeçalho: qual sinalização e qual ponto estão vigentes para atualização -->
<div class="master-file-heading" *ngIf="signSvg || signLabel">
  <img *ngIf="signSvg" [src]="signSvg" class="master-file-heading-icon" alt="">
  <div class="master-file-heading-text">
    <small class="text-muted">Sinalização</small>
    <strong>{{ signLabel || 'Sinalização selecionada' }}</strong>
  </div>
  <span class="master-file-active-point">
    Posicionando o ponto <strong>{{ selectedPoint || '—' }}</strong>
  </span>
</div>

<!-- Controles: escolher ponto A/B e limpar -->
<div class="d-flex align-items-center flex-wrap master-file-controls">
  <span class="mr-2">Posicionar:</span>
  <button type="button" class="btn btn-sm mr-2"
    [ngClass]="selectedPoint === 'A' ? 'btn-primary' : 'btn-outline-primary'"
    (click)="selectPoint('A')">Ponto A</button>
  <button *ngIf="allowB" type="button" class="btn btn-sm mr-2"
    [ngClass]="selectedPoint === 'B' ? 'btn-primary' : 'btn-outline-primary'"
    (click)="selectPoint('B')">Ponto B</button>
  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="resetPoints()">Limpar</button>
  <small *ngIf="allowB" class="text-muted ml-3">O ponto B é opcional.</small>
</div>

<!-- Coordenadas -->
<div class="master-file-coords">
  <span *ngIf="selectedPointA.posX" [class.active]="selectedPoint === 'A'"><strong>A</strong>: {{ selectedPointA.posX.toFixed(0) }}, {{ selectedPointA.posY.toFixed(0) }}</span>
  <span *ngIf="allowB && selectedPointB.posX" class="ml-3" [class.active]="selectedPoint === 'B'"><strong>B</strong>: {{ selectedPointB.posX.toFixed(0) }}, {{ selectedPointB.posY.toFixed(0) }}</span>
</div>

<div class="row mx-0">
  <!-- PDF -->
  <ng-container *ngIf="isPdf">
    <div class="col px-0">
      <p class="text-muted mb-3 mt-2" *ngIf="selectedPoint">
        Clique na página do PDF para posicionar o ponto <strong>{{ selectedPoint }}</strong>.
      </p>
      <app-pdf-viewer class="w-100" style="display:block; height: 70vh;"
        [src]="pdfSrc"
        [editable]="true"
        [markers]="pdfMarkers"
        [lines]="pdfLines"
        (pageClick)="onPdfPageClick($event)"></app-pdf-viewer>
    </div>
  </ng-container>

  <!-- Imagem -->
  <ng-container *ngIf="!isPdf">
    <div class="col px-0">
      <div class="master-file-edit" id="master-file-edit">
        <img class="w-100" [src]="selectedFile" id="viewMaster" #viewMaster
          [style.cursor]="selectedPoint ? 'crosshair' : 'default'"
          (load)="onImageLoad(viewMaster)"
          (click)="onImageClick($event, viewMaster)">

        <!-- Linha tracejada A-B -->
        <svg class="master-line-layer" *ngIf="imageLine(viewMaster) as l"
          [attr.width]="viewMaster.offsetWidth" [attr.height]="viewMaster.offsetHeight">
          <line [attr.x1]="l.x1" [attr.y1]="l.y1" [attr.x2]="l.x2" [attr.y2]="l.y2"></line>
        </svg>

        <!-- Referências (outras sinalizações no mesmo arquivo-mestre) -->
        <span class="master-marker-wrap reference" *ngFor="let ref of referenceImagePoints"
          [style]="GetMarkerPosition(viewMaster, ref)">
          <img class="master-marker-icon" [src]="ref.svg">
        </span>

        <!-- Ponto A -->
        <span class="master-marker-wrap" *ngIf="selectedPointA.posX"
          [class.active]="selectedPoint === 'A'"
          [style]="GetMarkerPosition(viewMaster, selectedPointA)">
          <img class="master-marker-icon" [src]="iconFor('A')">
          <span class="master-marker-label" *ngIf="labelFor('A')">A</span>
        </span>
        <!-- Ponto B -->
        <span class="master-marker-wrap" *ngIf="allowB && selectedPointB.posX"
          [class.active]="selectedPoint === 'B'"
          [style]="GetMarkerPosition(viewMaster, selectedPointB)">
          <img class="master-marker-icon" [src]="iconFor('B')">
          <span class="master-marker-label" *ngIf="labelFor('B')">B</span>
        </span>
      </div>
    </div>
  </ng-container>
</div>
